const { mergeMap } = require('rxjs/operators')
const { ofType } = require('redux-observable')

const { user: userApi } = require('@doctoroncallcom/api')
const {
  POST_USER,
  IMPORT_USER,
  EMAIL_OTP,

  GET_ALL_USERS,
  GET_SINGLE_USER,
  UPDATE_USER,
  DELETE_USER,
  GET_ADMIN_DOCTORS_LIST,
  GET_ADMIN_DOCTOR,
  CREATE_ADMIN_DOCTOR,
  UPDATE_ADMIN_DOCTOR,
  UPDATE_ADMIN_DOCTOR_STATUS,
  POST_ADMIN_DOCTOR_DIGITAL_SIG,
  REVOKE_ADMIN_DOCTOR_DIGITAL_SIG,
  POST_ADMIN_DOCTOR_SPECS,
  DELETE_ADMIN_DOCTOR,

  GET_ALL_ADMIN_PANEL_USERS,
  GET_SINGLE_ADMIN_PANEL_USER,
  CREATE_ADMIN_PANEL_USER,
  UPDATE_ADMIN_PANEL_USER,

  GET_LOGGED_IN_USER,
  GET_PROFILE,
  UPDATE_PROFILE,
  POST_DOC_DIGITAL_INFO,
  USER_LOGIN,
  USER_REGISTRATION,
  APPLE_LOGIN,
  LOGIN_GOOGLE,
  NUMBER_VALIDATION,
  UPDATE_EMAIL,
  UPDATE_NUMBER,
  USER_LOGOUT,
  FORGOT_PASSWORD,
  PASSWORD_CHANGE,
  MARKETPLACE_PASSWORD_CHANGE,

  GET_DOCTOR_DETAILS,
  GET_DOCTOR_ID,
  POST_DOCTOR_PIN,
} = require('./constants')

const {
  postUserSuccess,
  postUserError,

  importUserSuccess,
  importUserError,

  getAllUsersListSuccess,
  getAllUsersListError,

  getSingleUserSuccess,
  getSingleUserError,

  updateUserSuccess,
  updateUserError,

  deleteUserSuccess,
  deleteUserError,
  
  
  emailOtpSuccess,
  emailOtpError,


  getAdminDoctorsListSuccess,
  getAdminDoctorsListError,

  getAdminDoctorSuccess,
  getAdminDoctorError,

  createAdminDoctorSuccess,
  createAdminDoctorError,

  updateAdminDoctorSuccess,
  updateAdminDoctorError,

  updateAdminDoctorStatusSuccess,
  updateAdminDoctorStatusError,

  postAdminDoctorDigitalSigSuccess,
  postAdminDoctorDigitalSigError,

  revokeAdminDoctorDigitalSigSuccess,
  revokeAdminDoctorDigitalSigError,

  postAdminDoctorSpecsSuccess,
  postAdminDoctorSpecsError,

  deleteAdminDoctorSuccess,
  deleteAdminDoctorError,

  getAllAdminPanelUsersSuccess,
  getAllAdminPanelUsersError,
  getAdminPanelUserSuccess,
  getAdminPanelUserError,
  createAdminPanelUserSuccess,
  createAdminPanelUserError,
  updateAdminPanelUserSuccess,
  updateAdminPanelUserError,

  getLoggedInUserSuccess,
  getLoggedInUserError,

  getProfileSuccess,
  getProfileError,

  updateProfileSuccess,
  updateProfileError,

  postDocDigitalInfoSuccess,
  postDocDigitalInfoError,

  userLoginSuccess,
  userLoginError,

  userRegistrationSuccess,
  userRegistrationError,

  appleLoginSuccess,
  appleLoginError,

  loginGoogleSuccess,
  loginGoogleError,

  validatePhoneNumberSuccess,
  validatePhoneNumberError,

  updateEmailSuccess,
  updateEmailError,

  updateNumberSuccess,
  updateNumberError,

  forgotPasswordSuccess,
  forgotPasswordError,

  userLogoutSuccess,
  userLogoutError,

  changePasswordSuccess,
  changePasswordError,

  marketPlacePasswordChangeSuccess,
  marketPlacePasswordChangeError,

  getDoctorDetailsSuccess,
  getDoctorDetailsError,

  getDoctorIdSuccess,
  getDoctorIdError,

  postDoctorPinSuccess,
  postDoctorPinError,
} = require('./actions')

const postUser = (action$, state$, { api }) => action$.pipe(
  ofType(POST_USER),
  mergeMap(action => userApi
    .postUser(api, action.payload.userData)
    .then(response => postUserSuccess(response.data))
    .catch(error => postUserError(error))),
)

const importUser = (action$, state$, { api }) => action$.pipe(
  ofType(IMPORT_USER),
  mergeMap(action => userApi
    .importUser(api, action.payload.userData)
    .then(response => importUserSuccess(response))
    .catch(error => importUserError(error))),
)

const getAllUsersList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_ALL_USERS),
  mergeMap(action => userApi
    .getUsersListApi(api, {
      take: action.payload.take,
      skip: action.payload.skip,
      email: action.payload.email,
      phoneNumber: action.payload.phoneNumber,
    })
    .then(response => getAllUsersListSuccess(response.data))
    .catch(error => getAllUsersListError(error))),
)

const getSingleUser = (action$, state$, { api }) => action$.pipe(
  ofType(GET_SINGLE_USER),
  mergeMap(action => userApi
    .getSingleUserApi(api, action.payload.id)
    .then(response => getSingleUserSuccess(response.data))
    .catch(error => getSingleUserError(error))),
)

const updateUser = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_USER),
  mergeMap(action => userApi
    .updateUserApi(api, action.payload.id, action.payload.userData)
    .then(response => updateUserSuccess(response.data))
    .catch(error => updateUserError(error))),
)

const deleteUser = (action$, state$, { api }) => action$.pipe(
  ofType(DELETE_USER),
  mergeMap(action => userApi
    .deleteUserApi(api, action.payload.id)
    .then(response => deleteUserSuccess(response.data))
    .catch(error => deleteUserError(error))),
)

const getAdminDoctorsList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_ADMIN_DOCTORS_LIST),
  mergeMap(action => userApi
    .getAdminDoctorsListApi(api, {
      take: action.payload.take,
      skip: action.payload.skip,
      email: action.payload.email,
      phoneNumber: action.payload.phoneNumber,
      search: action.payload.search,
      find: action.payload.find,
      role: action.payload.role,
    })
    .then(response => getAdminDoctorsListSuccess(response.data))
    .catch(error => getAdminDoctorsListError(error))),
)

const getAdminDoctor = (action$, state$, { api }) => action$.pipe(
  ofType(GET_ADMIN_DOCTOR),
  mergeMap(action => userApi
    .getAdminDoctorApi(api, action.payload.id)
    .then(response => getAdminDoctorSuccess(response.data))
    .catch(error => getAdminDoctorError(error))),
)

const createAdminDoctor = (action$, state$, { api }) => action$.pipe(
  ofType(CREATE_ADMIN_DOCTOR),
  mergeMap(action => userApi
    .createAdminDoctorApi(api, action.payload.docData)
    .then(response => createAdminDoctorSuccess(response.data))
    .catch(error => createAdminDoctorError(error))),
)

const updateAdminDoctor = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_ADMIN_DOCTOR),
  mergeMap(action => userApi
    .updateAdminDoctorApi(api, action.payload.id, action.payload.docData)
    .then(response => updateAdminDoctorSuccess(response.data))
    .catch(error => updateAdminDoctorError(error))),
)

const updateAdminDoctorStatus = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_ADMIN_DOCTOR_STATUS),
  mergeMap(action => userApi
    .updateAdminDoctorStatusApi(
      api,
      action.payload.id,
      action.payload.statusData,
    )
    .then(response => updateAdminDoctorStatusSuccess(response.data))
    .catch(error => updateAdminDoctorStatusError(error))),
)

const postAdminDoctorDigitalSig = (action$, state$, { api }) => action$.pipe(
  ofType(POST_ADMIN_DOCTOR_DIGITAL_SIG),
  mergeMap(action => userApi
    .postAdminDoctorDigitalSigApi(
      api,
      action.payload.id,
      action.payload.docData,
    )
    .then(response => postAdminDoctorDigitalSigSuccess(response.data))
    .catch(error => postAdminDoctorDigitalSigError(error))),
)

const revokeAdminDoctorDigitalSig = (action$, state$, { api }) => action$.pipe(
  ofType(REVOKE_ADMIN_DOCTOR_DIGITAL_SIG),
  mergeMap(action => userApi
    .revokeAdminDoctorDigitalSigApi(
      api,
      action.payload.id,
    )
    .then(response => revokeAdminDoctorDigitalSigSuccess(response.data))
    .catch(error => revokeAdminDoctorDigitalSigError(error))),
)

const postAdminDoctorSpecs = (action$, state$, { api }) => action$.pipe(
  ofType(POST_ADMIN_DOCTOR_SPECS),
  mergeMap(action => userApi
    .postAdminDoctorSpecsApi(
      api,
      action.payload.id,
      action.payload.specData,
    )
    .then(response => postAdminDoctorSpecsSuccess(response.data))
    .catch(error => postAdminDoctorSpecsError(error))),
)

const deleteAdminDoctor = (action$, state$, { api }) => action$.pipe(
  ofType(DELETE_ADMIN_DOCTOR),
  mergeMap(action => userApi
    .deleteAdminDoctorApi(api, action.payload.id)
    .then(response => deleteAdminDoctorSuccess(response.data))
    .catch(error => deleteAdminDoctorError(error))),
)

const getadminPanelUsersList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_ALL_ADMIN_PANEL_USERS),
  mergeMap(action => userApi.getAdminPanelUsersListApi(api, {
    role: action.payload.role,
    take: action.payload.take,
    skip: action.payload.skip,
    search: action.payload.search,
    email: action.payload.email,
    phoneNumber: action.payload.phoneNumber,
  })
    .then(response => getAllAdminPanelUsersSuccess(response.data))
    .catch(error => getAllAdminPanelUsersError(error))),
)

const getSingleAdminPanelUser = (action$, state$, { api }) => action$.pipe(
  ofType(GET_SINGLE_ADMIN_PANEL_USER),
  mergeMap(action => userApi.getSingleAdminPanelUserApi(api, action.payload.id)
    .then(response => getAdminPanelUserSuccess(response.data))
    .catch(error => getAdminPanelUserError(error))),
)

const createAdminPanelUser = (action$, state$, { api }) => action$.pipe(
  ofType(CREATE_ADMIN_PANEL_USER),
  mergeMap(action => userApi.createAdminPanelUserApi(api, action.payload.adminData)
    .then(response => createAdminPanelUserSuccess(response.data))
    .catch(error => createAdminPanelUserError(error))),
)

const updateAdminPanelUser = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_ADMIN_PANEL_USER),
  // eslint-disable-next-line max-len
  mergeMap(action => userApi.updateAdminPanelUserApi(api, action.payload.id, action.payload.adminData)
    .then(response => updateAdminPanelUserSuccess(response.data))
    .catch(error => updateAdminPanelUserError(error))),
)

const updateProfile = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_PROFILE),
  mergeMap(action => userApi
    .putProfile(api, action.payload.user)
    .then(response => updateProfileSuccess(response.data))
    .catch(error => updateProfileError(error))),
)
const updateEmail = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_EMAIL),
  mergeMap(action => userApi
    .updateEmail(api, {
      code: action.payload.code,
      sessionId: action.payload.sessionId,
      email: action.payload.email,
    })
    .then(response => updateEmailSuccess(response.data))
    .catch(error => updateEmailError(error))),
)
const updateNumber = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_NUMBER),
  mergeMap(action => userApi
    .updateEmail(api, {
      code: action.payload.code,
      sessionId: action.payload.sessionId,
      countryCode: action.payload.countryCode,
      phoneNumber: action.payload.phoneNumber,
    })
    .then(response => updateNumberSuccess(response.data))
    .catch(error => updateNumberError(error))),
)
const postDocDigitalInfo = (action$, state$, { api }) => action$.pipe(
  ofType(POST_DOC_DIGITAL_INFO),
  mergeMap(action => userApi
    .postDocDigitalInfoApi(api, action.payload.info)
    .then(response => postDocDigitalInfoSuccess(response.data))
    .catch(error => postDocDigitalInfoError(error))),
)

const getLoggedInUser = (action$, state$, { api }) => action$.pipe(
  ofType(GET_LOGGED_IN_USER),
  mergeMap(() => userApi
    .me(api)
    .then(response => getLoggedInUserSuccess(response.data))
    .catch(error => getLoggedInUserError(error))),
)

const logoutUser = (action$, state$, { api }) => action$.pipe(
  ofType(USER_LOGOUT),
  mergeMap(() => userApi
    .logoutUser(api)
    .then(response => userLogoutSuccess(response.data))
    .catch(error => userLogoutError(error))),
)

const profile = (action$, state$, { api }) => action$.pipe(
  ofType(GET_PROFILE),
  mergeMap(() => userApi
    .getProfile(api)
    .then(response => getProfileSuccess(response.data))
    .catch(error => getProfileError(error))),
)

//email Otp
const emailOtp = (action$, state$, { api }) =>
  action$.pipe(
    ofType(EMAIL_OTP),
    mergeMap((action) =>
      userApi
      
        .Emailcode(api, {
          email: action.payload.email,
          recaptchaToken: action.payload.recaptchaToken,
        })
        .then((response) => emailOtpSuccess(response.data))
        .catch((error) => emailOtpError(error))
    )
  );



const loginUser = (action$, state$, { api }) => action$.pipe(
  ofType(USER_LOGIN),
  mergeMap(action => userApi
    .login(api, {
      email: action.payload.email,
      password: action.payload.password,
      recaptchaToken: action.payload.recaptchaToken,
    })
    .then(response => userLoginSuccess(response.data))
    .catch(error => userLoginError(error))),
)

// forgot

const forgotPasswords = (action$, state$, { api }) => action$.pipe(
  ofType(FORGOT_PASSWORD),
  mergeMap(action => userApi
    .forgetPassword(api, {
      phoneNumber: action.payload.phoneNumber,
      email: action.payload.email,
      password: action.payload.password,
      sessionId: action.payload.sessionId,
      code: action.payload.code,
      recaptchaToken: action.payload.recaptchaToken,
    })
    .then(response => forgotPasswordSuccess(response.data))
    .catch(error => forgotPasswordError(error))),
)

const userRegisteration = (action$, state$, { api }) => action$.pipe(
  ofType(USER_REGISTRATION),
  mergeMap(action => userApi
    .register(api, {
      email: action.payload.email,
      name: action.payload.name,
      password: action.payload.password,
      age: action.payload.age,
      phoneNumber: action.payload.phoneNumber,
      height: action.payload.height,
      dob: action.payload.dob,
      weight: action.payload.weight,
      gender: action.payload.gender,
      verificationStatus: action.payload.verificationStatus,
      emailVerificationStatus: action.payload.emailVerificationStatus,
      countryCode: action.payload.countryCode,
      sessionId: action.payload.sessionId,
      planId: action.payload.planId,
      partnerId: action.payload.partnerId,
      referrer: action.payload.referrer,
      code: action.payload.code,
      recaptchaToken: action.payload.recaptchaToken,
    })
    .then(response => userRegistrationSuccess(response.data))
    .catch(error => userRegistrationError(error))),
)

const appleLogin = (action$, state$, { api }) => action$.pipe(
  ofType(APPLE_LOGIN),
  mergeMap(action => userApi
    .loginApple(api, {
      identityToken: action.payload.identityToken,
      user: action.payload.user,
      referrer: action.payload.referrer,
    })
    .then(response => appleLoginSuccess(response.data))
    .catch(error => appleLoginError(error))),
)
const loginGoogle = (action$, state$, { api }) => action$.pipe(
  ofType(LOGIN_GOOGLE),
  mergeMap(action => userApi
    .loginGoogle(api, {
      googleAccessToken: action.payload.googleAccessToken,
      referrer: action.payload.referrer,
    })
    .then(response => loginGoogleSuccess(response.data))
    .catch(error => loginGoogleError(error))),
)
const validatePhoneNumber = (action$, state$, { api }) => action$.pipe(
  ofType(NUMBER_VALIDATION),
  mergeMap(action => userApi
    .validatePhoneNumber(api, {
      type: action.payload.type,
      countryCode: action.payload.countryCode,
      phoneNumber: action.payload.phoneNumber,
      recaptchaToken: action.payload.recaptchaToken,
    })
    .then(response => validatePhoneNumberSuccess(response.data))
    .catch(error => validatePhoneNumberError(error))),
)
const changePassword = (action$, state$, { api }) => action$.pipe(
  ofType(PASSWORD_CHANGE),
  mergeMap(action => userApi
    .changePassword(api, {
      sessionId: action.payload.sessionId,
      code: action.payload.code,
      password: action.payload.password,
      recaptchaToken: action.payload.recaptchaToken,
    })
    .then(response => changePasswordSuccess(response.data))
    .catch(error => changePasswordError(error))),
)

const marketPlacePasswordChange = (action$, state$, { api }) => action$.pipe(
  ofType(MARKETPLACE_PASSWORD_CHANGE),
  mergeMap(action => userApi
    .changePasswordMarketplace(api, {
      oldPassword: action.payload.oldPassword,
      newPassword: action.payload.newPassword,
      retypePassword: action.payload.retypePassword,
      recaptchaToken: action.payload.recaptchaToken,
    })
    .then(response => marketPlacePasswordChangeSuccess(response.data))
    .catch(error => marketPlacePasswordChangeError(error))),
)

const getDoctorDetailsEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_DOCTOR_DETAILS),
  mergeMap(action => userApi
    .getDoctorDetailsApi(api, action.payload.id)
    .then(response => getDoctorDetailsSuccess(response.data))
    .catch(error => getDoctorDetailsError(error))),
)

// eslint-disable-next-line no-unused-vars
const getDoctorIdEpic = (action$, state$) => action$.pipe(
  ofType(GET_DOCTOR_ID),
  mergeMap(action => userApi
    .getDoctorIdApi(action.payload.id)
    .then(response => getDoctorIdSuccess(response.data))
    .catch(error => getDoctorIdError(error))),
)

const postDoctorPinEpic = (action$, state$, { api }) => action$.pipe(
  ofType(POST_DOCTOR_PIN),
  mergeMap(action => userApi.postDoctorPinApi(api, action.payload.pinData)
    .then(response => postDoctorPinSuccess(response.data))
    .catch(error => postDoctorPinError(error))),
)

module.exports = {
  postUser,
  importUser,
  getAllUsersList,
  getSingleUser,
  updateUser,
  deleteUser,
  getAdminDoctorsList,
  getAdminDoctor,
  createAdminDoctor,
  updateAdminDoctor,
  updateAdminDoctorStatus,
  postAdminDoctorDigitalSig,
  revokeAdminDoctorDigitalSig,
  postAdminDoctorSpecs,
  deleteAdminDoctor,

  getadminPanelUsersList,
  getSingleAdminPanelUser,
  createAdminPanelUser,
  updateAdminPanelUser,

  forgotPasswords,
  getLoggedInUser,
  profile,
  updateProfile,
  postDocDigitalInfo,
  loginUser,
  userRegisteration,
  appleLogin,
  loginGoogle,
  validatePhoneNumber,
  updateEmail,
  updateNumber,
  logoutUser,
  changePassword,
  marketPlacePasswordChange,
  getDoctorDetailsEpic,
  getDoctorIdEpic,
  postDoctorPinEpic,
  emailOtp
}